import {Component} from '@angular/core';
import { NotificationService } from '../../../services/notification.service';

import {BaMsgCenterService} from './baMsgCenter.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ba-msg-center',
  providers: [BaMsgCenterService],
  styleUrls: ['./baMsgCenter.scss'],
  templateUrl: './baMsgCenter.html'
})
export class BaMsgCenter {

  public totalNotifications: number;
  public notifications: Array<Object>;
  public messages: Array<Object>;

  constructor(
    private _baMsgCenterService: BaMsgCenterService,
    private notificationService: NotificationService,
    private _router: Router  ) {
    // this.notifications = this._baMsgCenterService.getNotifications();
    // this.messages = this._baMsgCenterService.getMessages();
    this.getNotifications();
  }

  getNotifications() {
    if (localStorage.getItem('id_token')) {
      const status = [];
      status.push ('0'); // no leído
      this.notificationService.getNotifications(status)
      .subscribe(
      data => {
        this.notifications = data.notifications;
        this.totalNotifications = this.notifications.length;
      },
      error => {
        if (error.status === 404) {
          this.notifications = [];
          this.totalNotifications = 0;
        } else {
          console.log(error);
          this.notifications = [];
          this.totalNotifications = 0;
        }
      });
    }
  }

  gotoNotifications() {
    this._router.navigate(['/pages/viewnotification']);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baMsgCenter/baMsgCenter.component.ts